import { SectionWrapper } from "../../../../../UI/SectionWrapper/SectionWrapper";
import { Accordion, AccordionSummary } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { AssetAccordionDetails } from "../../../../ui-components/pageLayout/TableSettingsComponents";
import { FieldArray } from "formik";
import { EntitySelectionTable } from "../../../../ui-components/pageLayout/EntitySelectionTable";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CustomerPortalState, store } from "../../../../store";
import { CMSCollection } from "../../../../../../models/CMS/cmsCollection";
import {
  GetCollectionsAction,
  getMediaCollectionsSelector,
} from "../../../../store/reducers/cmsReducer";

const FeatureSetMediaCollectionsAccordion: React.FC = () => {
  const mediaCollections = useSelector(getMediaCollectionsSelector);
  const [filteredMediaCollections, setFilteredMediaCollections] =
    useState<CMSCollection[]>();

  useEffect(() => {
    store.dispatch(GetCollectionsAction());
  }, []);

  useEffect(() => {
    setFilteredMediaCollections(mediaCollections);
  }, [mediaCollections]);

  const mediaCollectionSearchFunc = (query: string) => {
    setFilteredMediaCollections(
      mediaCollections.filter((mediaCollection) =>
        mediaCollection
          .getDisplayName()
          .toLowerCase()
          .includes(query.toLowerCase())
      )
    );
  };

  return (
    <SectionWrapper>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          className="accordion-summary-gray"
        >
          Media Collections
        </AccordionSummary>
        <AssetAccordionDetails>
          <FieldArray
            name="mediaCollections"
            render={({ move, push, remove, form }) => (
              <EntitySelectionTable
                label="media collections"
                values={filteredMediaCollections}
                selectedValues={form.values.mediaCollections?.map((id) =>
                  mediaCollections.find(
                    (mediaCollection) => id === mediaCollection.getUniqueId()
                  )
                )}
                searchFunction={mediaCollectionSearchFunc}
                push={(entity) => push(entity.getUniqueId())}
                remove={remove}
                noImages={true}
              />
            )}
          />
        </AssetAccordionDetails>
      </Accordion>
    </SectionWrapper>
  );
};

export default FeatureSetMediaCollectionsAccordion;
